import { render, staticRenderFns } from "./getUserInfo.vue?vue&type=template&id=39fb7270&scoped=true"
import script from "./getUserInfo.vue?vue&type=script&lang=ts"
export * from "./getUserInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fb7270",
  null
  
)

export default component.exports